import { NewsCriticsContext } from "contexts/MightyTool";
import { useContext } from "react";
const useNewsCritics = () => useContext(NewsCriticsContext);
export default useNewsCritics;
